module.exports = __webpack_public_path__ + "static/media/pre_owned_title@2x.8fb7ac62.png";